const UPDATES = [
  { date: '07-30', title: '《繁华似锦》大结局上线', desc: '全40集一次放出，会员抢先看完大结局', tag: '热播' },
  { date: '07-29', title: '《逆光之恋》更新至16集', desc: '男女主角感情线迎来重大转折', tag: '新剧' },
  { date: '07-28', title: '《长安十二时辰》4K修复版上线', desc: '经典国产悬疑剧高清重制', tag: '经典' },
  { date: '07-27', title: '韩剧专区新增5部高分剧集', desc: '《秘密森林》《我的大叔》等口碑佳作', tag: '专区' },
  { date: '07-26', title: '港剧经典回顾专题上线', desc: 'TVB黄金年代经典剧集全收录', tag: '专题' },
  { date: '07-25', title: '《风起洛阳》播放量突破千万', desc: '古装悬疑大剧持续走热', tag: '热门' },
  { date: '07-24', title: '《请回答2028》登录红桃影视', desc: '高分韩剧独家上线，全20集完整版', tag: '上线' },
  { date: '07-23', title: '暑期追剧季活动开启', desc: '每日推荐高分好剧，发现更多精彩内容', tag: '活动' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100/60 text-secondary-700 text-xs font-medium mb-4">
              剧集动态
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              最新上架
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              实时追踪最新剧集上线动态，不错过任何一部好剧
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>

            <div className="space-y-6 md:space-y-8">
              {UPDATES.map((item, i) => (
                <div key={i} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14 group cursor-pointer">
                  <div className={`absolute left-2.5 md:left-4.5 top-1 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full border-2 ${
                    i === 0
                      ? 'bg-primary-500 border-primary-500'
                      : 'bg-background-100 border-background-300 group-hover:border-primary-400'
                  } transition-colors`}
                  style={i === 0 ? {} : { left: 'calc(1rem + 0.5px)' }}
                  ></div>

                  <span className="flex-shrink-0 text-xs text-foreground-400 font-medium w-10 md:w-12 whitespace-nowrap">
                    {item.date}
                  </span>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-400 transition-colors">
                        {item.title}
                      </h3>
                      <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100/70 text-primary-600 font-medium whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-xs md:text-sm text-foreground-500 mt-1">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}